import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';

const FeaturedArticles = ({ filteredArticles }) => {
    console.log(filteredArticles,"vvvvvvvvv")
    const navigate=useNavigate()
    const [query, setQuery] = useState("");
    const tagConfig = {
        GUIDE: { bg: "bg-blue-100", text: "text-blue-700" },
        BLOG: { bg: "bg-green-100", text: "text-green-700" },
        WELLNESS: { bg: "bg-red-100", text: "text-red-600" },
        MINDFULNESS: { bg: "bg-purple-100", text: "text-purple-700" },
    };
    return (
        <div className=' px-14 mt-4'> 
         <div className="mb-5 flex flex-wrap items-baseline justify-between gap-2">
            <div>
                <h2 className=" mb-1"
                    className="ava-heading-lg "
                >Featured Articles</h2>
                <p className="mt-0.5 ava-text-body">
                    Curated reads to inform, inspire, and support.
                </p>
            </div>
        </div>
            <div className="mb-12 grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-3 ">
                {filteredArticles?.articles.length > 0 ? (
                    filteredArticles?.articles.map((article) => {
                        const tc = tagConfig[article.tag] ||
                            { bg: "bg-slate-100", text: "text-slate-600" };
                        return (
                            <div
                                key={article.id}
                                className="group cursor-pointer overflow-hidden rounded-2xl ava-border bg-white 
                                        "
                            >

                                {/* transition-all duration-200
                                        hover:-translate-y-1 hover:shadow-xl hover:shadow-[0_0px_2px_var(--primary-color)] */}

                                <img src={article.image} alt={article.title}
                                    className="w-full aspect-[3/2] sm:aspect-[4/3] md:aspect-[16/9] object-cover object-center"
                                />
                                <div className="p-4">
                                    <div className="mb-2 flex items-center justify-between gap-2">
                                        <span className="rounded-md px-2.5 py-0.5  ava-text-caption tracking-wide ava-card-bg  whitespace-nowrap">
                                            {article.tag}
                                        </span>
                                        <span className="flex items-center gap-1 ava-text-caption">
                                            <div className="flex h-7 w-7 items-center justify-center rounded-full">
                                                <img src='/Resources/time.svg' alt="" className="h-4 w-4 object-contain" />
                                            </div>
                                            {article.readTime}
                                        </span>
                                    </div>
                                    <p className="mb-1.5 ava-text-subheading">{article.title}</p>
                                    <p className="mb-3 ava-text-body">{article.description}</p>
                                    <button className="ava-text-sm" onClick={()=>navigate('/resource')}>
                                        Read more
                                    </button>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <p className="col-span-full text-sm text-slate-400">
                        No articles found for &ldquo;{query}&rdquo;.
                    </p>
                )}
            </div></div>
    )
}

export default FeaturedArticles